import { createRouter, createWebHistory } from "vue-router";
import PostView from "../views/PostView.vue";
import SearchView from "../views/SearchView.vue";
import NoticeView from "../views/NoticeView.vue";

const SITE_NAME = "XPZ社区";

const routes = [
  {
    path: "/",
    name: "home",
    component: PostView,
    meta: { title: "首页" },
  },
  { path: "/post", redirect: "/" },
  {
    path: "/post/:id",
    name: "post-detail",
    component: PostView,
    meta: { title: "动态详情" },
  },
  {
    path: "/search",
    name: "search",
    component: SearchView,
    meta: { title: "搜索" },
  },
  {
    path: "/notice",
    name: "notice",
    component: NoticeView,
    meta: { title: "通知" },
  },
  {
    path: "/oauth/callback/gitee",
    name: "oauth-callback-gitee",
    component: () => import("../views/OAuthCallbackView.vue"),
    meta: { title: "登录中" },
  },
  {
    path: "/oauth/callback/qq",
    name: "oauth-callback-qq",
    component: () => import("../views/OAuthCallbackView.vue"),
    meta: { title: "登录中" },
  },
  {
    path: "/profile",
    name: "profile",
    component: () => import("../views/ProfileView.vue"),
    meta: { title: "个人中心" },
  },
  {
    path: "/profile/:userId",
    name: "profile-user",
    component: () => import("../views/ProfileView.vue"),
    meta: { title: "用户主页" },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

function resolveDocumentTitle(to) {
  const pageTitle = to.meta && to.meta.title;
  if (pageTitle) {
    return `${pageTitle} - ${SITE_NAME}`;
  }
  return `${SITE_NAME} - 分享与交流`;
}

// 路由标题 + 百度统计
router.afterEach((to) => {
  if (typeof document !== "undefined") {
    document.title = resolveDocumentTitle(to);
  }
  if (typeof window !== "undefined" && window._hmt) {
    window._hmt.push(["_trackPageview", to.fullPath]);
  }
});

export default router;
